import {updatedDomColorsFromThemeSettings} from "../utils/colorHelper.mjs";
import {notifyError, notifySuccess} from "@ignitesales/neuro-application";

const DialogueActions = {
    THEME_COLORS_UPDATED: 'COLORS_UPDATED',
    THEME_DIALOGUE_GUIDE_SETTINGS_UPDATED: 'THEME_DIALOGUE_GUIDE_SETTINGS_UPDATED',
    THEME_CONFIGURATION_UPDATED: 'CONFIGURATION_UPDATED',
    CONTACT_PAGE_COMPLETED: 'CONTACT_PAGE_COMPLETED',
    CONTACT_PAGE_STATE_UPDATED: 'CONTACT_PAGE_STATE_UPDATED'
};

const DialogueActionsStorageKeys = {
    THEME_RUNNER_SETTINGS: 'THEME_RUNNER_SETTINGS',
    THEME_RUNNER_COLORS: 'THEME_RUNNER_COLORS',
    THEME_RUNNER_GUIDE_SETTINGS: 'THEME_RUNNER_GUIDE_SETTINGS'
};

const setThemeConfiguration = (newThemeSettings) => {
    return async (dispatch, getState) => {
        const { themeName, themeManifest } = getState();
        if (newThemeSettings) {
            window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_SETTINGS, JSON.stringify({
                themeName,
                themeSettings: newThemeSettings
            }));
            updatedDomColorsFromThemeSettings(themeManifest, newThemeSettings);
            dispatch({ type: DialogueActions.THEME_CONFIGURATION_UPDATED, themeSettings: newThemeSettings });
            notifySuccess('themeConfigurationUpdated');
        } else {
            notifyError('themeRunnerColorsUpdated');
        }
    };
};

const setDialogueGuideConfiguration = (dialogueSettingsConfig) => {
    return async (dispatch) => {
        if (dialogueSettingsConfig) {
            window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_GUIDE_SETTINGS, JSON.stringify(dialogueSettingsConfig));
            dispatch({ type: DialogueActions.THEME_DIALOGUE_GUIDE_SETTINGS_UPDATED, dialogueGuideSettings: dialogueSettingsConfig });
            notifySuccess('themeConfigurationUpdated');
        } else {
            notifyError('themeRunnerColorsUpdated');
        }
    };
};

const setContactPageState = ({isActive}) => {
    return async (dispatch) => {
        dispatch({
            type: DialogueActions.CONTACT_PAGE_STATE_UPDATED,
            isActive
        });
    }
};

const onContactPageCompleted = () => {
    return async (dispatch) => {
        ignite.answerService.saveAnswer({
            appkey: 'hasCompletedContactForm',
            value: true,
            timestamp: new Date()
        });
        dispatch({ type: DialogueActions.CONTACT_PAGE_COMPLETED })
    }
};


export {
    DialogueActions,
    DialogueActionsStorageKeys,
    setThemeConfiguration,
    setDialogueGuideConfiguration,
    setContactPageState,
    onContactPageCompleted
};
